/** Represents a standardized data-structure based on an HTML Form that can be POSTed and validated */
export default class FORMPOST {
    id; // Unique ID of the FormPost
    formId; // The FORM UId that this FORMPOST belongs to
    results; // An ordered array of key/value pairs as they appear in the FORM (form.getResultsAsArray())
    message; // Message from the server
    __RequestVerificationToken; // Anti-CSRF token
    /** Constructs a FORMPOST for the given form
        @param formId Form UId
        @param formResults Form Results An ordered array of key/value pairs as they appear in the FORM (form.getResultsAsArray())
    */
    constructor(formId, formResults = []) {
        this.id = formId;
        this.formId = formId;
        this.results = formResults;
        this.message = '';
        this.__RequestVerificationToken = this.results[this.results.length - 1].value;
    }
}
